import { onGlobalVarSet } from '@mm/utils';
import { IS_PROD_URL } from './constants';

// prettier-ignore
export const initFacebookPixel = () => {
  /* eslint-disable */
  /* tslint:disable */
  // @ts-ignore
  !function(f,b,e,v,n,t,s) {if(f.fbq)return;n=f.fbq=function(){n.callMethod? n.callMethod.apply(n,arguments):n.queue.push(arguments)}; if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0'; n.queue=[];t=b.createElement(e);t.async=!0; t.src=v;s=b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t,s)}(window,document,'script', 'https://connect.facebook.net/en_US/fbevents.js'); fbq('init', '204139566819177');
  /* tslint:enable */
  /* eslint-enable */
};

export const trackFacebookEvent = async (eventName: string) => {
  if (IS_PROD_URL) {
    const fbq = await onGlobalVarSet<any>('fbq');
    fbq('track', eventName);
  }
};
